module.exports = __webpack_public_path__ + "media/asset/images/word-ea43ee9b9ac224e04456d99334f2f649.png";